module.exports = __webpack_public_path__ + "img/ilustration-sent.06aa923e.svg";